<!-- Page Header End -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container text-center">
    <!--Video Section Start -->
    <app-youtube-player [videoID]="TOUR_DATA"></app-youtube-player>
    <!-- Video Section End -->
  </div>
</div>
<!-- Page content end -->
